module.exports = __webpack_public_path__ + "img/routes.63782a84.svg";